import Deeplink from "./deeplink";
export default Deeplink;